"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _redux = require("redux");

var _ActionTypes = require("ContentData/actions/ActionTypes");

var fonts = function fonts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.GOOGLE_FONTS_FETCH_FONTS:
      {
        var response = action.response;
        if (!(response && response.results)) return state;
        return response.results.reduce(function (hash, font) {
          hash[font.family] = font;
          return hash;
        }, (0, _extends3.default)({}, state));
      }

    case _ActionTypes.GOOGLE_FONTS_CLEAR:
      {
        if (Object.keys(state).length) return {};
        return state;
      }

    default:
      return state;
  }
};

var selectedFonts = function selectedFonts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.GOOGLE_FONTS_FETCH_FONT:
      {
        var response = action.response;
        if (!(response && response.results)) return state;
        return response.results.reduce(function (hash, font) {
          hash[font.family] = font;
          return hash;
        }, (0, _extends3.default)({}, state));
      }

    case _ActionTypes.SELECT_GOOGLE_FONT:
      {
        var font = action.font;
        return (0, _extends3.default)({}, state, (0, _defineProperty2.default)({}, font.family, font));
      }

    default:
      return state;
  }
};

var commonFonts = function commonFonts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.GOOGLE_FONTS_FETCH_COMMON_FONTS:
      {
        var response = action.response;
        if (!(response && response.results)) return state;
        return response.results;
      }

    default:
      return state;
  }
};

var _default = (0, _redux.combineReducers)({
  fonts: fonts,
  selectedFonts: selectedFonts,
  commonFonts: commonFonts
});

exports.default = _default;
module.exports = exports.default;